import { useEffect } from 'react';
import useLocalStorageState from 'use-local-storage-state';

import { useUser } from '../hooks/users';
import WebSocketConnection from './WebSocketConnection';

const _connection = new WebSocketConnection();

// make it available via window object
window['wsConnection'] = _connection;

export const useWebSocket = (): void => {
  const [storedUser] = useLocalStorageState('user', {
    defaultValue: undefined,
  });

  const user = useUser();

  useEffect(() => {
    _connection.updateCredential(user, (storedUser || {})['authToken']);
  }, [storedUser, user]);
};
/**
 * Add a message listener to the web socket connection.
 */
export const useWebSocketMessageListener = (
  callback: (message: Record<string, unknown>) => void
): void => {
  useEffect(() => {
    return _connection.bindMessage(callback);
  }, [callback]);
};
